<template>
  <div class="mb-3">
    <b-row v-if="!disabled">
      <b-col md="2">
        <label>Cliente*</label>
      </b-col>
      <b-col md="8">
        <select-box
          v-model="clienteElegido"
          :url="urlAutocompletarClientes"
          :options="opcionesCliente"
          @input="cambiarCliente"
        />
      </b-col>
      <b-col md="2">
        <b-button @click="mostrarModalCrearCliente" class="btn btn-success btn-block"> Crear cliente </b-button>
      </b-col>
    </b-row>
    <b-row v-else>
      <b-col md="2">
        <label>Cliente*</label>
      </b-col>
      <b-col md="10">
        <b-form-input v-model="cliente.nombre" disabled />
      </b-col>
    </b-row>
    <modal-crear-cliente
      v-model="creandoCliente"
      :pais="pais"
      :sectores="sectores"
      :unidad-negocio="unidadNegocio"
      @crear="onCrear"
    />
  </div>
</template>

<script>
import { mapState, mapActions } from "pinia";
import { useSessionStore } from "@/stores/SessionStore";
import { useOfertaFormStore } from "@/stores/OfertaFormStore";

import ModalCrearCliente from "./ModalCrearCliente";
import * as clienteApi from "@/services/clientes.js";
import * as sectorApi from "@/services/sectores.js";

export default {
  components: {
    ModalCrearCliente,
  },
  props: {
    disabled: { type: Boolean, default: false },
  },
  computed: {
    ...mapState(useSessionStore, ["esAdmin"]),
    ...mapState(useOfertaFormStore, ["cliente", "pais", "ofertaBase", "unidadNegocio"]),
    opcionesCliente() {
      if (!this.cliente) {
        return [];
      }
      return [{ id: this.cliente.id, text: this.cliente.nombre }];
    },
    urlAutocompletarClientes() {
      return `clientes/autocompletar&unidadNegocioId=${this.ofertaBase.unidadNegocioId}&paisId=${this.pais.id}`;
    },
  },
  data() {
    return {
      clienteElegido: null,
      creandoCliente: false,
      sectores: [],
    };
  },
  mounted() {
    this.clienteElegido = this.cliente.id;
  },
  methods: {
    ...mapActions(useOfertaFormStore, ["cambiarCliente"]),
    async listarSectores() {
      this.sectores = await sectorApi.listar();
    },
    async onCrear(cliente) {
      const response = await clienteApi.insertar(cliente);
      this.creandoCliente = false;
      this.cambiarCliente(response.id);
      this.clienteElegido = response.id;
    },
    async mostrarModalCrearCliente() {
      await this.listarSectores();
      this.creandoCliente = true;
    },
  },
};
</script>
